


import {GET_FillAdminBundleNo} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminBundleNo: null
 
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillAdminBundleNo:
            return {
                AdminBundleNo: action.body
              
              
            }
           

        default:
            return state;
    }
}